import {Component, computed, inject} from '@angular/core';
import {Title} from "../../../../components/title/title";
import {TranslatePipe} from "@ngx-translate/core";
import {TabItem, TabMenu} from '../../../../components/tab-menu/tab-menu';
import {RouterOutlet} from '@angular/router';
import {FinancesPeriodStore} from '../../services/finances-period.store';
import {CurrentUserService} from '../../../../services/current-user.service';

@Component({
  selector: 'elcia-finances-home',
  imports: [
    Title,
    TranslatePipe,
    TabMenu,
    RouterOutlet,

  ],
  providers: [FinancesPeriodStore],
  templateUrl: './finances-home.html',
  styleUrl: './finances-home.scss',
})
export class FinancesHome {


  currentUserService = inject(CurrentUserService);

  items = computed<TabItem[]>(() => {
    const hasPeppolAccess = this.currentUserService.hasPeppolAccess();
    const menu: TabItem[] = [
      {icon: 'credit-card', label: 'entity.invoices', route: 'invoices'},
      {icon: 'credit-note', label: 'entity.credit-notes', route: 'credit-notes'},
      {icon: 'sync', label: 'entity.direct-debits', route: 'direct-debit'},
      {icon: 'download', label: 'accounting-export.title', route: 'export'},
    ]
    if (hasPeppolAccess) {
      menu.push({icon: 'globe', label: 'app.peppol', route: 'peppol'})
    }
    return menu;
  });

}
